import Header from './Header';
import Content from './Content';
import { TableColumn as Column, TableRow } from './types';
import useTableHandlers from './useTableHandlers';

const HeadlessImmutableTable = {
  Header,
  Content,
  useTableHandlers,
};

export default HeadlessImmutableTable;
export type { Column, TableRow };
